import { SentEmail } from './sendEmai';

export class Approved {
    appEmailId: number;
    senderId: string;
    ccId: string;
    toId: string;
    body: string;
    dateTime: string;
    amount: number;
    hide: boolean
    star: boolean;
    deleted: boolean;
    extra1: string;
    extra2: string;
    createdOn: string;
    updatedOn: string;
    emailData_Id: number;
    email_Id:number;
    user_id: number;
    emailData: string;
    attachment: Attachment[];
    sub: Sub[];
    remark: Remark[];
    spec: Specification[];
    subBindGrid:string;
    specBindGrid:string;
    remarkBindGrid:string;
}

export class Attachment {
    fileId: number;
    fileType: string;
    fileSize: number;
    filePath: string;
    user_id: number;
    fileName:string;
}

export class Sub {
    subjectId: number;
    name: string;
}

export class Remark {
    remarkId: number;
    name: string;
}

export class Specification {
    specificationId: number;
    name: string;
}

export class updateApproved {
    appEmailId: number;
    senderID: string;
    ccId: string;
    toId: string;
    body: string;
    date_time: string;
    amount: number;
    hide: boolean
    star: boolean;
    deleted: boolean;
    extra1: string;
    extra2: string;
    createdOn: string;
    updatedOn: string;
    email_Id: number;
    user_id: number;
    emailData: string;
    attachment: Attachment[];
    sub: Sub[];
    remark: Remark[];
    spec: Specification[];
}
export class sendEmailmultiple{
    approved:Approved[];
    sendEmail:SentEmail[];
    emailid:string;
}
